
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project",
      function () {
        return require("private-next-pages/project/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project"])
      });
    }
  